export const SENHA_MINIMO = 6;
export const SENHA_MAXIMO = 100;

/**
 * Regra da senha nova, a mesma que o servidor cobra na troca e na recuperação
 * (RegrasDeSenha.cs na API). Só caracteres ASCII visíveis: a senha é cifrada
 * sobre bytes ASCII, e um "ç" viraria "?" no banco. O login, que decifra e
 * compara, nunca mais aceitaria a senha digitada.
 */
export const problemaDaSenhaNova = (senha: string): string | null => {
  if (senha.length < SENHA_MINIMO)
    return `A senha nova precisa de ao menos ${SENHA_MINIMO} caracteres.`;
  if (senha.length > SENHA_MAXIMO) return `O limite é ${SENHA_MAXIMO} caracteres.`;
  if (/[^\x20-\x7E]/.test(senha))
    return "Use letras sem acento, números e símbolos do teclado. Acentos, ç e emoji não são aceitos.";
  return null;
};
